import Button from './Button';
import { ToggleButtonWrapper } from './ToggleButton.styles';

interface ToggleButtonProps {
  toggleVertically?: boolean;
  isExpanded: boolean;
  onClick?: () => void;
}

const ToggleButton = ({
  toggleVertically = false,
  isExpanded,
  onClick = () => {},
}: ToggleButtonProps) => {
  return (
    <Button
      onClick={() => onClick?.()}
      className="btn btn-xs btn-link"
      $noOutlineWhenFocus
    >
      <ToggleButtonWrapper
        $isExpanded={isExpanded}
        $vertical={toggleVertically}
      />
    </Button>
  );
};

export default ToggleButton;
